import React, { useState } from "react";
import styles from "../../assets/styles/Marketers/Marketers.module.scss";
import { AppPage, MimaText, PageLoader } from "../../components";
import MimaOptionMenu from "../../components/OptionMenu";
import { AnimatePresence } from "framer-motion";

import { UpdateStyleCategoryContainer } from "../../containers";

const StyleCategories = ({
  styleCategories,
  closeModal,
  isLoading,
  updateCategoryModal,
  options,
  handleUpdate,
}) => {
  const [singleCategory, setSingleCategory] = useState([]);

  return (
    <AppPage pageTitle="Style Categories">
      {isLoading ? (
        <PageLoader title="while we load your information" />
      ) : (
        <div>
          {styleCategories?.map((item, i) => (
            <div key={i}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5rem",
                  margin: "4rem",
                }}
              >
                <MimaText variant="subtitleBold" align="center" mb={1}>
                  {item.type}
                </MimaText>
                <MimaOptionMenu
                  options={options}
                  onOptionSelected={(option) => {
                    setSingleCategory(item);
                    if (option.value === "Update Category") {
                      handleUpdate();
                    }
                  }}
                />
              </div>
              <div className={styles.insights__group}>
                {item?.categories?.map((x, index) => (
                  <div key={index} className={styles.card}>
                    <div className={styles.option}>
                      <MimaText variant="bodyBold" mb={0.5}>
                        {x.category}
                      </MimaText>
                    </div>
                    <div>
                      {x?.subCategories?.map((x, index) => (
                        <div
                          key={index}
                          className={styles.insights__group__item}
                        >
                          <MimaText variant="small" mb={0.5}>
                            {x}
                          </MimaText>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      {updateCategoryModal && (
        <div className="modal">
          <AnimatePresence>
            {updateCategoryModal && (
              <UpdateStyleCategoryContainer
                closeModal={closeModal}
                singleCategory={singleCategory}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default StyleCategories;
